export { default as SendBirdProvider } from './SendbirdProvider.js';
export { default as App } from './App.js';
export { default as ChannelSettings } from './ChannelSettings.js';
export { default as ChannelList } from './ChannelList.js';
export { default as Channel, getAllEmojisFromEmojiContainer, getEmojiCategoriesFromEmojiContainer, getEmojisFromEmojiContainer } from './Channel.js';
import { S as SendbirdSdkContext } from './LocalizationContext-f9cc3a84.js';
export { g as getStringSet, w as withSendBird } from './LocalizationContext-f9cc3a84.js';
export { default as OpenChannel } from './OpenChannel.js';
export { default as OpenChannelSettings } from './OpenChannelSettings.js';
export { default as MessageSearch } from './MessageSearch.js';
export { s as sendBirdSelectors } from './index-58bb39c7.js';
import { useContext } from 'react';
import 'prop-types';
import 'sendbird';
import './actionTypes-f3a1a3e6.js';
import './index-49fe86ba.js';
import 'css-vars-ponyfill';
import './index-48f41226.js';
import './LeaveChannel-2edea8f9.js';
import './index-ccb0a3c2.js';
import './index-5bed92c4.js';
import './utils-0e572de6.js';
import './index-fc337826.js';
import './index-d00418ca.js';
import './index-e2d20807.js';
import './index-23738504.js';
import 'react-dom';

/**
 * Example:
 * const MyComponent = () => {
 *  const context = useSendbirdStateContext();
 *  const sdk = sendbirdSelectors.getSdk(context);
 *  return (<div>...</div>);
 * }
 */

function useSendbirdStateContext() {
  var context = useContext(SendbirdSdkContext);
  return context;
}

export { useSendbirdStateContext };
//# sourceMappingURL=index.js.map
